import React, { InputHTMLAttributes } from "react";

const InputControl: React.FC<InputHTMLAttributes<HTMLInputElement>> = (
  props
) => {
  return (
    <div className="flex flex-col gap-2 items-start">
      <label htmlFor={props.id} className="font-medium capitalize text-lg">
        {props.name}
      </label>
      <input
        {...props}
        className={`bg-transparent px-4 py-2 secondary-outline border primary-border-color rounded-lg w-full ${props.className}`}
      />
    </div>
  );
};

export default InputControl;
